



import HealthForceGoApp from '@/lib/HealthForceGoApp';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class BadRequest extends Vue {
  mounted() {
    this.$dialog.show({
      title: 'There was a problem accessing your course data.',
      buttons: [
        {
          label: 'Ok',
          handler: () => {
            HealthForceGoApp.dismiss();
          },
        },
      ],
    });
  }
}
